import { render, staticRenderFns } from "./OrderNotice.vue?vue&type=template&id=c3863c64&scoped=true"
import script from "./OrderNotice.vue?vue&type=script&lang=js"
export * from "./OrderNotice.vue?vue&type=script&lang=js"
import style0 from "./OrderNotice.vue?vue&type=style&index=0&id=c3863c64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3863c64",
  null
  
)

export default component.exports